<template>
  <div class="login container">
    <div v-if="!userCanViewRedemptions()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <form v-else @submit.prevent="submit">

      <div class="row">
        <h2 class="col-md-12 pt-5">Redemptions</h2>
      </div>
      <div class="row">
        <p class="col-md-12 pt-2">Total redemptions between</p>
      </div>

        <div class="row d-flex justify-content-center">
        <div class="col-lg-3 size-limit">
          <date-time-picker
            label=""
            :dark="true"
            v-model="from_time"
            color="#6A819A"
            format="YYYY-MM-DD HH:mm:ss"
            formatted="LLLL"
            :noClearButton="true"
          />
        </div>
        <div class="col-md-3 pt-lg-4">
          and
        </div>
        <div class="col-lg-3 size-limit">
          <date-time-picker
            label=""
            :dark="true"
            v-model="to_time"
            color="#6A819A"
            format="YYYY-MM-DD HH:mm:ss"
            formatted="LLLL"
            :noClearButton="true"
          />
        </div>
        </div>


      <div class="row d-flex justify-content-center">
          <div class="loader absolute" v-show="submitted"></div>
        <h1 :class="{loading:submitted}">{{redemption_amount_formatted}}</h1>
      </div>
    </form>
   
  </div>
</template>

<script>

export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
        submitted: false,
        from_time: null,
        to_time  : null,
        redemption_amount:0
      };
  },
  watch:{

    from_time:function()
    {
      this.submit(); 
    },
    to_time:function()
    {
      this.submit();
    }

  },
  created:function(){

    let start = new Date();
    start.setHours(0,0,0,0);
    this.from_time = start.toISOString().slice(0, 19).replace('T', ' ');

    let end = new Date();
    end.setHours(23,59,59,999);
    this.to_time = end.toISOString().slice(0, 19).replace('T', ' ');

  },
  computed: {

    unit()
    {
      return this.$store.getters.getUnit;
    },
    account()
    {
      return this.$store.getters.getAccount;
    },

    accountCurrency(){
      return this.$store.getters.getAccountCurrency;
    },

    redemption_amount_formatted(){
      return this.getPriceDisplay(this.accountCurrency,Math.abs(this.redemption_amount));
    }
  },
  methods:{

      /*
      * Login form submit handler
      */
      submit()
      {

        if(!this.from_time || !this.to_time || !this.userCanViewRedemptions())
          return false;

        this.$validator.validateAll().then((result) => {
          if(result){

            this.submitted = true;

            window.axios({
                url: process.env.VUE_APP_API_GRAPH_URL,
                method: 'post',
                data: {
                query: `
                  query(
                    $redemptions_line_item_type_ids:[Int],
                    $sales_line_item_type_ids:[Int],
                    $date_from:String,
                    $date_to:String,
                    $unit_id:Int,
                    $account_id:Int
                    $restrict_pos_units:Boolean
                  )
                        {
                            redemptions: LineItemsSum(line_item_type_ids:$redemptions_line_item_type_ids,
                              date_from:$date_from,
                              date_to:$date_to,
                              unit_id:$unit_id,
                              account_id:$account_id,
                              restrict_pos_units:$restrict_pos_units
                            ),
                            sales: LineItemsSum(line_item_type_ids:$sales_line_item_type_ids,
                              date_from:$date_from,
                              date_to:$date_to,
                              unit_id:$unit_id,
                              account_id:$account_id

                            ),
                        }
                      `,
                      variables: {
                        redemptions_line_item_type_ids: [2],
                        sales_line_item_type_ids      : [1],
                        date_from                     : this.from_time,
                        date_to                       : this.to_time,
                        unit_id                       : this.unit.id,
                        account_id                    : this.account.id,
                        restrict_pos_units            : true
                      }
              }
            }).then((result) => {
              let error_to_error = {
                'unit_id':'unit_id'
              }

              this.validateGraphResponse(result,error_to_error);
              if (this.errors.has('unit_id')) {
                this.$bus.$emit('error_message', result.data.errors[0].validation.unit_id[0]);
              }

              this.redemption_amount = result.data.data.redemptions;
            }).catch( () => {
                this.$bus.$emit('error_message', 'Something went wrong, please try again!');
            }).then(() => {
                this.submitted = false;
            });

            
          }
        });
          
      },

     


  }
}
</script>

<style >

.two{
  padding-top:30px !important;
}

h1{
    transition: text-shadow 0.5s, transform 0.5s;
    text-shadow: 0 0 0 rgba(255,255,255,0.5);
    font-size: 3em;
}

h1.loading{
   color: transparent;
   text-shadow: 0 0 5px rgba(255,255,255,0.5);
   transform: scale(0.7); /* Equal to scaleX(0.7) scaleY(0.7) */
}

 

</style>
